<!-- followers-following.html -->
<div class="min-h-[200px]">

  <!-- Loading (first page only — later pages show a spinner under the list) -->
  <ng-container *ngIf="isLoading() && users().length === 0">
    <div class="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
      <div *ngFor="let i of [1,2,3,4,5,6,7,8]"
           class="animate-pulse bg-white rounded-2xl p-5 flex flex-col items-center gap-3 shadow-sm">
        <div class="w-20 h-20 rounded-full bg-gray-200"></div>
        <div class="w-28 h-4 rounded bg-gray-200"></div>
        <div class="w-20 h-3 rounded bg-gray-200"></div>
      </div>
    </div>
  </ng-container>

  <!-- Empty -->
  <ng-container *ngIf="!isLoading() && !error() && allLoaded() && users().length === 0">
    <div class="flex flex-col items-center justify-center py-20 text-center">
      <p class="text-gray-400 text-sm">
        {{ type === 'follower' ? 'No followers yet.' : 'Not following anyone yet.' }}
      </p>
    </div>
  </ng-container>

  <!-- List -->
  <ng-container *ngIf="users().length > 0">
    <div class="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
      @for (user of users(); track user._id) {

        <!-- Entire card is a router link -->
        <a
          [routerLink]="['/profile', user.userName, 'post']"
          class="profile-card group bg-white rounded-2xl p-5 flex flex-col items-center gap-2 shadow-sm
                 cursor-pointer no-underline
                 transition-all duration-200 ease-out
                 hover:-translate-y-1 hover:shadow-md"
        >
          <!-- Avatar with hover ring -->
          <div class="relative">
            <img
              [src]="user?.profileImage?.urlMedium ?? avatarFallback(user.displayName)"
              [alt]="user.displayName"
              class="w-20 h-20 rounded-full object-cover
                     ring-2 ring-transparent group-hover:ring-brand-400
                     transition-all duration-200"
            />
          </div>

          <!-- Name & username -->
          <div class="text-center mt-1">
            <p class="font-semibold text-gray-900 text-sm leading-tight line-clamp-1 group-hover:text-brand-500 transition-colors duration-150">
              {{ user.displayName }}
            </p>
            <p class="text-gray-400 text-xs mt-0.5">@{{ user.userName }}</p>
          </div>

          <!-- Subtle "View profile" hint on hover -->
          <span class="mt-1 text-xs text-brand-500 opacity-0 group-hover:opacity-100 transition-opacity duration-150 font-medium">
            View profile →
          </span>
        </a>

      }
    </div>

    <!-- Infinite scroll: entering view loads the next page -->
    <div *ngIf="!allLoaded() && !error()" #sentinel class="flex justify-center py-6">
      <button type="button" (click)="loadNextPage()" [disabled]="isLoading()"
        class="rounded-lg border border-[#d8d8d8] bg-[#f8f8f8] px-4 py-1.5 text-xs font-semibold text-gray-700 hover:bg-gray-100 disabled:opacity-60">
        {{ isLoading() ? 'Loading…' : 'Load more' }}
      </button>
    </div>
  </ng-container>

  <!-- Error -->
  <ng-container *ngIf="error()">
    <div class="flex flex-col items-center gap-3 py-10 text-center">
      <p class="text-sm text-gray-500">{{ error() }}</p>
      <button type="button" (click)="retry()"
        class="rounded-lg border border-[#d8d8d8] bg-[#f8f8f8] px-4 py-1.5 text-xs font-semibold text-gray-700 hover:bg-gray-100">
        Try again
      </button>
    </div>
  </ng-container>

</div>